const BrandMark = ({ size = 16, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    className={className}
    aria-hidden="true"
    data-testid="brand-mark-icon"
  >
    <path
      d="M24 42C15.2 42 9.5 34.6 9.5 27.2C9.5 22.4 10.9 19.2 12.4 17.4C15.5 20.4 19.5 22.2 24 22.2C28.5 22.2 32.5 20.4 35.6 17.4C37.1 19.2 38.5 22.4 38.5 27.2C38.5 34.6 32.8 42 24 42Z"
      fill="#1F3A2B"
    />
    <circle cx="24" cy="15.5" r="9.5" fill="#E5A94E" />
  </svg>
);

export default BrandMark;
